import {
  Delete,
  Get,
  getAPIUrl,
  Post,
  Put,
} from "../../../ApiServices/apiMethod";
import { HomePageService } from "../../../ApiServices/Axios/Index";

export const NewsEndpoint = {
  getNews: `/admin/news/list`,
  getNewsbyId: `/admin/news/details/`,
  addNews: `/admin/news/add/`,
  editNews: `/admin/news/edit/`,
  deleteNews: `/admin/news/delete/`,
  uploadImage: `/admin/news/uploadImage`
};

export const getNews = (param = "") => {
  const url = getAPIUrl(NewsEndpoint.getNews, param);
  return Get(HomePageService, url, true);
};

export const getNewsbyId = (param = "") => {
  const url = getAPIUrl(NewsEndpoint.getNewsbyId, param);
  return Get(HomePageService, url, true);
};

export const addNews = (data, param = "") => {
  const url = getAPIUrl(NewsEndpoint.addNews, param);
  return Post(HomePageService, url, data, true);
};

export const editNews = (data, param = "") => {
  const url = getAPIUrl(NewsEndpoint.editNews, param);
  return Put(HomePageService, url, data, true);
};

export const deleteNews = (param = "") => {
  const url = getAPIUrl(NewsEndpoint.deleteNews, param);
  return Delete(HomePageService, url, param);
};

export const uploadImage = (data) => {
  const formData = new FormData();
  Object.keys(data).forEach((k) => {
    if (data[k]) {
      formData.append(k, data[k]);
    }
  });
  const url = getAPIUrl(NewsEndpoint.uploadImage);
  return Post(HomePageService, url, formData, true, true);
};